"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import staticData from "@/public/data/landing.json";
import Flex from "@/shared/components/common/Flex";
import FloatingButton from "@/shared/components/common/floatingButton";
import Typography from "@/shared/components/common/Typography";
// import { isActivePath } from "@/shared/libs/url-utils";
import Link from "next/link";
// import { usePathname } from "next/navigation";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";

interface CallSupportProps {
  phone: string;
}

export default function CallSupport({ phone }: CallSupportProps) {
  const { label, activeRoutes } = staticData.callSupport;

  // if (!isActivePath(activeRoutes, usePathname())) return null;

  const handleGTMEvent = () => {
    sendGTMEvent({
      event: "call_support",
      label: label,
      value: phone,
    });
  };

  return (
    <Link href={`tel:${phone}`} onClick={handleGTMEvent}>
      <FloatingButton classNames="group bg-success shadox-sm hover:shadow-md px-4 py-2 md:py-3 ring-0 hover:ring-1 hover:ring-primary hover:bg-background transition ease-in-out duration-100 bottom-14">
        <Flex
          gap={"2"}
          alignItems={"center"}
          justifyContent={"center"}
          className=""
        >
          <span className="animate-zoom scale-x-[-1]">
            <PhosphorIcon
              name="Phone"
              size={24}
              weight="fill"
              className="text-background dark:text-foreground group-hover:text-primary transition ease-in-out duration-100"
            />
          </span>
          <Typography
            variant={"body3"}
            className="text-background dark:text-foreground group-hover:text-primary font-medium transition ease-in-out duration-100"
          >
            {phone}
          </Typography>
        </Flex>
      </FloatingButton>
    </Link>
  );
}
